import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { HeroUIProvider, ToastProvider } from '@heroui/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import App from './app/App';
import amplifyConfig from './amplifyConfig';
import { queryClient } from './lib/queryClient';
import { OrganizationProvider } from './contexts/OrganizationContext';
import Logger from './services/Logger';
import './index.css';

Logger.Init();

// Configure AWS Amplify
Amplify.configure(amplifyConfig);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <OrganizationProvider>
          <HeroUIProvider>
            <ToastProvider placement="top-right" />
            <App />
          </HeroUIProvider>
        </OrganizationProvider>
        {process.env.NODE_ENV === 'development' && (
          <ReactQueryDevtools initialIsOpen={false} />
        )}
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
